

















































































import Vue from 'vue'
import axios from 'axios'
import * as Sentry from '@sentry/browser'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

declare var paypal_sdk: any

interface ICheckoutData {
  status?: 'paid' | 'pending' | 'rejected'
  totalCostExTax?: number
  totalCostTax?: number
  totalCost?: number
  taxRate?: number
}

@Component
export default class Checkout extends Vue {
  @Prop({ type: Number, required: true })
  practicumId!: number

  @Prop({ required: true})
  shipping!: any;

  @Prop({ default: false })
  showButton!: boolean

  @Prop({ required: true })
  data!: ICheckoutData

  unexpectedClose = false

  transactionComplete = false

  orderID = null

  get showPaypalButton() {
    return this.showButton && (!this.data.status || this.data.status !== 'paid')
  }

  get showPaymentWindow() {
    return !this.transactionComplete && !this.unexpectedClose && (!this.data.status || this.data.status !== 'paid')
  }

  get userId() {
    return +this.$route.params.userId || this.$store.state.auth.userId
  }

  @Watch('showButton')
  async dataLoaded() {
    if (this.showPaypalButton) {
      this.$nextTick(() => {
        this.loadPaypalButton()
      })
    }
  }

  async restartOrder() {
    this.unexpectedClose = false
    this.$nextTick(() => {
      this.loadPaypalButton()
    })
  }

  paymentSuccess() {
    this.transactionComplete = true
    this.$emit('success')
  }

  loadPaypalButton() {
    const component = this
    const practicumId = this.practicumId
    const shipping = this.shipping
    const userId = this.userId
    const onSuccess = this.paymentSuccess

    const paypal = (window as any).paypal
    paypal.Buttons({ // eslint-disable-line
      createOrder(data: {}, actions: {}) { // eslint-disable-line
        return axios.post(`/payments/practicums/${practicumId}/users/${userId}/order`, shipping).then((response) => {
          component.orderID = response.data.orderID
          // Sentry.configureScope(scope => {
          //   scope.setExtra('orderID', response.data.orderID)
          // })
          return response.data.orderID
        })
      },
      onApprove(data: { orderID: string }) {
        return axios.post(`/payments/practicums/${practicumId}/users/${userId}/confirm`, { orderID: data.orderID }).then((res) => {
          onSuccess()
        })
      },
      onError(err: any) { //eslint-disable-line
        component.unexpectedClose = true
        let formattedError
        try {
          // Sentry.captureException(err)
          formattedError = typeof err  === 'string' ? err : err.toString()
        }
        catch (error) {
          console.log(err, error)
        }

        const orderID = this.orderID || component.orderID 
        axios.post(`/payments/practicums/${practicumId}/users/${userId}/failed`, { orderID: component.orderID, error: formattedError })
      }
    }).render('#paypal-button-container')
  }
}
